import { Injectable, Query } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { CollectionsEntity } from "./collections.entity";
import { Repository, getManager } from "typeorm";
import { CommonResponse } from "@gtpl/shared-models/masters";
import appSettings from "apps/services/config";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { CollectionsFilters, CollectionsReq, DdbCollectionsReq, PaymentReq, PaymentTypeReq, ReceivablesDetailsReq, ReceivablesSummaryReq } from "@gtpl/shared-models/finance";
import {SoCustomerInvoice} from '../../../../sale-service/src/app/saleorder/customer-invoice.entity'
import {SaleOrderService} from '@gtpl/shared-services/sale-management'
import { CollectionPaymentTypes } from "@gtpl/shared-models/common-models";
@Injectable()
export class CollectionsService{
    constructor(
        @InjectRepository(CollectionsEntity)
        private repo: Repository<CollectionsEntity>,
        private soRepo: SaleOrderService

    ){}
    async getCollection(req:PaymentTypeReq):Promise<CommonResponse>{
        
        try{
            const manager = getManager()
            let query = `SELECT ci.invoice_number as invoiceNumber,ci.total_amount, ci.collection,ci.sale_order_id as soId,
            si.po_number as poNum,si.eda_date as eta,si.act_edl_date as etd,ci.total_amount - ci.collection AS totalAmount,ci.total_amount - ci.ddb_amt AS ddbAmt,
            b.bank_name as bankName ,b.id as bankId,
            ec.end_customer_name as buyer,ec.end_customer_id as buyerId,
            pt.payment_terms_name as paymentTerms,pt.payment_terms_id as paymentTermsId,
            c.port_code as port,c.cha,c.shipping_bill_date as shippingBillDate,c.shipping_bill_no as shippingBillNo
            FROM ${appSettings.sales_db}.customer_invoice ci
            LEFT JOIN ${appSettings.sales_db}.sale_order s ON s.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = si.pay_terms_id
            LEFT JOIN ${appSettings.masters_db}.bank_details b ON b.id = si.bank_account_id
            LEFT JOIN  ${appSettings.logistics_db}.container c ON c.sale_order_id =ci.sale_order_id
            WHERE 1=1`
            if(req.tab === CollectionPaymentTypes.EXPORT_RECEIVABLES){
                query += ` AND ci.total_amount - ci.collection > 0 `
            }
            if(req.tab === CollectionPaymentTypes.DUTY_DRAW_BACK){
                query += ` AND ci.total_amount - ci.ddb_amt > 0 `
            }
            if(req.buyer !== undefined){
                query += ` AND si.end_customer_id = '${req.buyer}'`
            }
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async generatePayment(req:CollectionsReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const entity = new CollectionsEntity()
                entity.bankCharges = req.bankCharges
                entity.buyerId = req.buyerId
                entity.bankId = req.bankId
                entity.buyerShortPayment = req.buyerShortPayment
                // entity.dueAmt = req.dueAmt
                entity.dueDate = req.dueDate?new Date(req.dueDate):null
                entity.eta = req.eta ? new Date(req.eta):null
                entity.etd = req.etd ? new Date(req.etd):null
                entity.invAmt = req.invAmt
                entity.invNum = req.invNum
                entity.paymentTermsId = req.paymentTermsId
                entity.poNum = req.poNum
                entity.recievedAmt = req.recievedAmt
                entity.soId = req.soId
                entity.recievedDate = req.recievedDate ? new Date(req.recievedDate):null
                entity.transactionStatus = req.transactionStatus
                entity.transactionType = req.transactionType
                entity.remarks = req.remarks
                entity.createdUser = req.createdUser
                entity.paymentType = req.payment
                const save = await transactionManager.getRepository(CollectionsEntity).save(entity)
                console.log(save,'saveeeeeeeeeeee')
if(save){
    console.log('uuuuuuuuuuuuuu');
    const  exist = await this.soRepo.getCustInvoiceDetails({saleOrderId:req.soId})    
    console.log(exist.data.collection,'ooooooooooooooooo');
    const collectionAmt = Number(req.recievedAmt) + Number(req.buyerShortPayment?req.buyerShortPayment:0)+Number(exist.data.collection)
    const request = new PaymentReq()
    request.soId = req.soId
    request.collection = collectionAmt
    const update = await this.soRepo.updateColletion(request)
    if(update){
        saveFlag.add(true)
    }else{
    saveFlag.add(false)
    await transactionManager.releaseTransaction()
    return new CommonResponse(false,0,'Something went wrong ')
    }
}
            // const result = await manager.query(query)
            // if(result.length > 0){
            //     return new CommonResponse(true, 1,'Data retrieved successfully', result)
            // }else{
            //     return new CommonResponse(false, 0,'No data found',[])
            // }
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in adjustment note save')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in adjustment note save',err)
        }
    }
    async generateDdbPayment(req:DdbCollectionsReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const entity = new CollectionsEntity()
                entity.scrollNo = req.scrollNo
                entity.buyerId = req.buyerId
                entity.scrollDate = req.scrollDate?new Date(req.scrollDate):null
                entity.invAmt = req.invAmt
                entity.invNum = req.invNum
                entity.recievedAmt = req.recievedAmt
                entity.soId = req.soId
                entity.recievedDate = req.recievedDate ? new Date(req.recievedDate):null
                entity.remarks = req.remarks
                entity.createdUser = req.createdUser
                entity.paymentType = req.payment
                const save = await transactionManager.getRepository(CollectionsEntity).save(entity)
                console.log(save,'saveeeeeeeeeeee')
if(save){
    console.log('uuuuuuuuuuuuuu');
    const  exist = await this.soRepo.getCustInvoiceDetails({saleOrderId:req.soId})    
    console.log(exist.data.collection,'ooooooooooooooooo');
    const totalAmt = Number(req.recievedAmt) + Number(exist.data.ddbAmt)
    const request = new PaymentReq()
    request.soId = req.soId
    request.collection = totalAmt
    if(exist){
    const update = await this.soRepo.updateDdb(request)
    if(update){
        saveFlag.add(true)
    }else{
    saveFlag.add(false)
    await transactionManager.releaseTransaction()
    return new CommonResponse(false,0,'Something went wrong ')
    }
}else{
    saveFlag.add(false)
    await transactionManager.releaseTransaction()
    return new CommonResponse(false,0,'No invoice found')
}
}
            // const result = await manager.query(query)
            // if(result.length > 0){
            //     return new CommonResponse(true, 1,'Data retrieved successfully', result)
            // }else{
            //     return new CommonResponse(false, 0,'No data found',[])
            // }
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in adjustment note save')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in adjustment note save',err)
        }
    }
    async getExportReceivablesData(req:CollectionsFilters):Promise<CommonResponse>{
        console.log(req,"--------------------")
        try{
             const manager = getManager()
             let tabquery = `SELECT c.id, c.po_num as poNum, c.recieved_amt as recievedAmt, c.bank_charges as bankCharges, 
             c.buyer_short_payment as buyerShortPayment,c.etd,c. eta,c.due_date as dueDate,c.received_date as recievedDate ,
             c.transaction_type as transactionType,c.transaction_status  as transactionStatus ,c.inv_num as invNum, c.inv_amt as invAmt, c.remarks ,
             ec.end_customer_name as endCustomerName,bd.bank_name as bankName, pt.payment_terms_name as paymentTermsName
                       FROM  ${appSettings.finance_db}.collections c
                       LEFT JOIN ${appSettings.masters_db}.bank_details bd ON bd. id = c.bank_id
                       LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec. end_customer_id = c.buyer_id
                       LEFT JOIN  ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = c.payment_terms_id
                       WHERE c.payment_type = "${CollectionPaymentTypes.EXPORT_RECEIVABLES}"`

                       if(req.buyer){
                        tabquery += ` AND c.buyer_id ='${req.buyer}' `
                       }
                       if(req.invNo){
                        tabquery +=` AND c.inv_num  = '${req.invNo}' `
                       }
                       

                       const result1 = await manager.query(tabquery)
                       if(result1.length>0){
                        return new  CommonResponse( true, 1,'Data retrieved successfully', result1)

                       }else{
                        return new CommonResponse(false, 0,'No data found',[])
                        
                       }
                      
        } catch(err){
            throw(err)
           }

    }
    async getDutyDrawBackData(req: CollectionsFilters): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let dutyquery = `SELECT
                co.shipping_bill_no as shippingBillNo, co.shipping_bill_date as shippingBillDate,
                co.cha, co.port_code as portCode,c.inv_num as invNum, c.inv_amt as invAmt,c.recieved_amt as recievedAmt,
                DATE(c.received_date) as receivedDate, c.scroll_no as scrollNo, DATE(c.scroll_date) as scrollDate, c.remarks,
                ec.end_customer_name as endCustomerName
                FROM ${appSettings.finance_db}.collections c
                LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = c.so_id 
                LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = c.buyer_id
                WHERE c.payment_type = "${CollectionPaymentTypes.DUTY_DRAW_BACK}"`;
    
            if (req.buyer) {
                dutyquery += ` AND c.buyer_id = '${req.buyer}' `;
            }
            if (req.invNo) {
                dutyquery += ` AND c.inv_num = '${req.invNo}' `;
            }
    
            const result2 = await manager.query(dutyquery);
            if (result2.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', result2);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
    
   async getBuyers(req:PaymentTypeReq):Promise<CommonResponse>{
        
        try{
            const manager = getManager()
            let query = `SELECT 
            ec.end_customer_name as buyer,ec.end_customer_id as buyerId
             FROM ${appSettings.sales_db}.customer_invoice ci
             LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            WHERE 1=1`
            if(req.tab === CollectionPaymentTypes.EXPORT_RECEIVABLES){
                query += ` AND ci.total_amount - ci.collection > 0 `
            }
            if(req.tab === CollectionPaymentTypes.DUTY_DRAW_BACK){
                query += ` AND ci.total_amount - ci.ddb_amt > 0 `
            }
            query += `GROUP BY ci.end_customer_id`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async getReceivablesSummaryReport(req:ReceivablesSummaryReq):Promise<CommonResponse>{
        console.log(req,'ooooooooooooooooo');
        
        try{
            const manager = getManager()
            let query = `SELECT c.so_id ,so.country_id,co.country_name as country,SUM(c.recieved_amt) as total,
            SUM(CASE WHEN u.company = 'BMR INDUSTRIES PRIVATE LIMITED' THEN c.recieved_amt ELSE 0 END) AS bmrAmt,
            SUM(CASE WHEN u.company != 'BMR INDUSTRIES PRIVATE LIMITED' THEN c.recieved_amt ELSE 0 END) AS otherAmt
            FROM ${appSettings.finance_db}.collections c
           LEFT JOIN ${appSettings.sales_db}.so_invoice_details so ON so.sale_order_id = c.so_id
           LEFT JOIN ${appSettings.masters_db}.countries co ON co.country_id = so.country_id
           LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id = so.factoryId
           WHERE c.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}'`
            if(req.fromDate != undefined){
                query +=` AND DATE(c.created_at) between '${req.fromDate}' and '${req.toDate}'`
            }

            query += ` GROUP BY co.country_name `
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async getReceivablesDetailsReport(req:ReceivablesDetailsReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `
            SELECT c.invoice_number AS invoiceNum, c.total_amount AS totalAmount,c.eta_date AS eta,so.po_number AS poNum,
            so.bank_account_id,so.pay_terms_id,so.end_customer_id ,co.bl_no AS blNo,c.invoice_date AS invDate,
            ec.end_customer_name AS customerName,b.bank_name AS bank,p.payment_terms_name AS paymentTerm,co.obl_etd as blDate,
            cl.recieved_amt AS paymentTerm,c.collection,cl.remarks,MAX(DATE(cl.received_date)) AS receivedDate
            FROM ${appSettings.sales_db}.customer_invoice c
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details so ON so.sale_order_id = c.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.bank_details b ON b.id = so.bank_account_id
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = so.end_customer_id
            LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = so.sale_order_id
            LEFT JOIN ${appSettings.finance_db}.collections cl ON cl.so_id = so.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.payment_terms p ON p.payment_terms_id = so.pay_terms_id
            WHERE YEAR(cl.created_at) = '${req.year}'`
            query += `GROUP BY c.invoice_id`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async getBuyerSDropDown():Promise<CommonResponse>{
    try{
        const manager=getManager()
        let query1 =`SELECT
        c.buyer_id as buyerId, ec. end_customer_name as buyerName
        FROM ${appSettings.finance_db}.collections c
        LEFT JOIN ${appSettings.masters_db}.end_customers ec ON  ec.end_customer_id  = c.buyer_id
        GROUP BY c.buyer_id `
        const result = await manager.query(query1)
        if(result.length > 0){
            return new CommonResponse(true, 1,'Data retrieved successfully', result)
        }else{
            return new CommonResponse(false, 0,'No data found',[])
        }

    }catch(err){
        throw(err)

    }
    
} 
async getInvoiceNumber():Promise<CommonResponse>{
    try{
        const manager =getManager()
        let query2 =`SELECT  c.inv_num as invNum 
        FROM ${appSettings.finance_db}.collections c
        GROUP BY c.inv_num`
        
        const result = await manager.query(query2)
        if(result.length>0){
            return new CommonResponse(true, 1,'Data retrieved successfully', result)
        }else{
            return new CommonResponse(false, 0,'No data found',[])
        }
    } catch(err){
        throw(err)
    }
}


}
